import { BreakpointObserver } from "@angular/cdk/layout";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MenuUtility } from "@app/shared/services/utils/menu-utility.service";
import { Observable, Subject, combineLatest, distinctUntilChanged, map, takeUntil } from "rxjs";

@Component({
    selector: "clare-main-content-container",
    templateUrl: "./main-content-container.component.html",
    styleUrls: ["./main-content-container.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainContentContainerComponent implements OnInit, OnDestroy {
    @Input() isNavNeeded = false;
    @Input() menuHeader = "";
    @Input() menuHeaderText = "";

    isMobile$: Observable<boolean>;

    isMenuOpened = false;
    requestClose$ = this.menuService.requestClose$
        .pipe(
            map(requestClose => {
                if (this.isMenuOpened) {
                    this.updateSecondaryMenuState(!requestClose);
                }
            })
        )
        .subscribe();
    private unsubscribe$ = new Subject();
    private _isNavNeeded$ = new Subject<boolean>();
    constructor(
        private readonly breakpointObserver$: BreakpointObserver,
        private readonly menuService: MenuUtility,
        private readonly cdr: ChangeDetectorRef
    ) {}

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
        this.menuService.menuOpenChange(false, false);
    }

    ngOnInit(): void {
        this.isMobile$ = this.breakpointObserver$.observe(["(max-width: 959px)"]).pipe(
            takeUntil(this.unsubscribe$),
            map(mobileQuery => mobileQuery.matches),
            distinctUntilChanged()
        );

        combineLatest({
            isMobile: this.isMobile$,
            isNavNeeded: this._isNavNeeded$,
        })
            .pipe(
                map(({ isMobile, isNavNeeded }) => !isMobile && isNavNeeded),
                takeUntil(this.unsubscribe$)
            )
            .subscribe(isMenuOpened => {
                setTimeout(() => this.updateSecondaryMenuState(isMenuOpened), 200);
            });

        this._isNavNeeded$.next(this.isNavNeeded);

        this.menuService.menuState$.pipe(takeUntil(this.unsubscribe$)).subscribe(menuState => {
            this.updateSecondaryMenuState(menuState);
        });
    }

    updateNavNeed(state = false) {
        this._isNavNeeded$.next(state);
    }

    toggleSecondaryMenu() {
        this.updateSecondaryMenuState(!this.isMenuOpened);
    }

    onMenuClose() {
        this.menuService.closeMenu();
    }

    updateSecondaryMenuState(isOpened = false) {
        this.isMenuOpened = isOpened;
        this.menuService.menuOpenChange(isOpened, this.isNavNeeded);
        this.cdr.markForCheck();
    }
}
